<template>
  <div class="list-field-alert">
    <strong v-if="title" class="list-field-alert__title">{{ title }}</strong>
    <span class="list-field-alert__value">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    label: String,
  },
}
</script>

<style lang="scss">
.list-field-alert {
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  padding: 0.85rem 1.1rem;
  margin-bottom: 0.75rem;
  font-size: 0.85rem;
  line-height: 1.5;

  &__title {
    margin-right: 1ch;
    font-weight: 700;
  }
}
</style>
